module.exports = new __parcel__URL__("add.7643c136.png").toString();